import { NumberUtils } from "@sinossi/mates-react-library"

export class Config
{
	private static INSTANCE: Config|null = null

	private _keycloakEnabled: boolean

	private _keycloakUrl: string|null
	private _keycloakRealm: string|null
	private _keycloakClientId: string|null
	private _keycloakTokenValidity: number

	private _mapsKey: string
	private _scan360Url: string

	private constructor()
	{
		this._keycloakEnabled = this.defaultBoolean(process.env.REACT_APP_KEYCLOAK_ENABLED, true)
		this._keycloakUrl = process.env.REACT_APP_KEYCLOAK_URL ?? null
		this._keycloakRealm = process.env.REACT_APP_KEYCLOAK_REALM ?? null
		this._keycloakClientId = process.env.REACT_APP_KEYCLOAK_CLIENT_ID ?? null
		this._keycloakTokenValidity = NumberUtils.toInteger(process.env.REACT_APP_KEYCLOAK_TOKEN_VALIDITY ?? "", 30)
		this._mapsKey = process.env.REACT_APP_MAPS_KEY ?? ""
		this._scan360Url = process.env.REACT_APP_SCAN360_URL ?? "https://storebook.scan360.app/"
	}

	public static init(): Config
	{
		if(Config.INSTANCE === null) {
			Config.INSTANCE = new Config()
		}

		return Config.INSTANCE
	}

	public get keycloakEnabled(): boolean
	{
		return this._keycloakEnabled
	}

	public get keycloakUrl(): string|null
	{
		return this._keycloakUrl
	}

	public get keycloakRealm(): string|null
	{
		return this._keycloakRealm
	}

	public get keycloakClientId(): string|null
	{
		return this._keycloakClientId
	}

	public get keycloakTokenValidity(): number
	{
		return this._keycloakTokenValidity
	}

	public get mapsKey(): string
	{
		return this._mapsKey
	}

	public get scan360Url(): string
	{
		return this._scan360Url
	}

	private defaultBoolean = (o: any, defaultValue: boolean): boolean => {
		if(o === null || o === undefined) {
			return defaultValue
		}
		if(typeof o === "string") {
			return o === "true"
		}

		return o as boolean
	}
}
